import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';

const SubscriptionUsage = ({ subscription, invoices }) => {
  const latestInvoice = invoices.length > 0 ? invoices[0] : null;
  const currentUsage = latestInvoice?.documents_count || 0;
  const maxLimit = subscription?.documents_limit || 0;
  const isUnlimited = maxLimit === 0;
  const usagePercentage = isUnlimited ? 0 : (currentUsage / maxLimit) * 100;

  return (
    <Box sx={{ width: '40%', mt: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="label">Document Usage</Typography>
        <Typography variant="body2">
          {isUnlimited ? (
            <>
              {currentUsage} documents used{' '}
              <Typography component="span" color="primary">
                (Unlimited)
              </Typography>
            </>
          ) : (
            `${currentUsage} of ${maxLimit} documents used`
          )}
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={isUnlimited ? 100 : usagePercentage}
        sx={{
          height: 10,
          borderRadius: 4,
          backgroundColor: '#e0e0e0',
          '& .MuiLinearProgress-bar': {
            backgroundColor: isUnlimited ? '#2196f3' : usagePercentage >= 90 ? '#f44336' : '#2196f3',
            borderRadius: 4,
          },
        }}
      />
      {!isUnlimited && (
        <Typography
          variant="caption"
          color={usagePercentage >= 90 ? 'error' : 'textSecondary'}
          sx={{ mt: 0.5, display: 'block' }}
        >
          {usagePercentage.toFixed(1)}% used
        </Typography>
      )}
    </Box>
  );
};

export default SubscriptionUsage;
